// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ef0b864e62bd45c00a7f","293":"0c8fa012127293afdd95","522":"fbc0bad46b066cdba32e"}[chunkId] + ".js";
};